import type { PlayerView } from '../../shared/protocol';

/**
 * `host` holds the role; `acting` is the connected member the server will hand it to on
 * their first host command while the host is offline; `guest` waits. Mirrors the server's
 * `claimHost` rule, restricted to the first eligible member so only one screen offers
 * host controls at a time.
 */
export type HostRole = 'host' | 'acting' | 'guest';

export function hostRole(
  players: readonly Readonly<Pick<PlayerView, 'id' | 'host' | 'connected'>>[],
  meId: string | null,
  /** False in turn-taking rooms, where the server never hands the role to a stand-in. */
  claimable = true,
): HostRole {
  if (!meId) return 'guest';
  const host = players.find((player) => player.host);
  if (host?.id === meId) return 'host';
  if (host?.connected || !claimable) return 'guest';
  const standIn = players.find((player) => player.connected && !player.host);
  return standIn?.id === meId ? 'acting' : 'guest';
}
